<template>
  <Card class="layout-card">
    <div class="search-form">
      <Input v-model="searchForm.keyword" :maxlength="100" placeholder="请输入主剧名称或中文剧名" clearable />
      <Input v-model="searchForm.type" :maxlength="50" placeholder="请输入类型" clearable />
      <Select v-model="searchForm.originalLangId" placeholder="请选择原始语言" clearable>
        <Option v-for="item in langList" :key="item.id" :value="item.id">
          {{ item.chineseLangName }}
        </Option>
      </Select>
      <Select v-model="channelSelect" placeholder="请选择频道" clearable @on-change="handleChannelChange">
        <Option v-for="item in channelList" :key="item.value" :value="item.value">{{ item.label }}</Option>
      </Select>
      <Button type="primary" @click="getData()">查询</Button>
      <Button @click="handleReset">重置</Button>
    </div>

    <div class="table-wrapper">
      <Table :data="tableData" :columns="columns" :loading="loading">
        <template #action="{ row }">
          <a @click="handleView(row)">查看</a>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>

    <Modal v-model="viewVisible" title="查看主剧" :width="1000" footer-hide>
      <Spin v-if="detailLoading" fix></Spin>
      <Form v-if="viewVisible" :label-width="130" class="detail-form">
        <Row :gutter="16">
          <Col :span="12">
            <FormItem label="主剧名称：">
              <Input :value="displayValue(detail.playName)" readonly />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="中文剧名：">
              <Input :value="displayValue(detail.chineseName)" readonly />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="原始语言：">
              <Input :value="displayValue(detail.originalLangName)" readonly />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem :label="`${detail.typeLabel || '类型'}：`">
              <Input :value="displayValue(detail.type)" readonly />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="频道：">
              <Input :value="displayValue(detail.channel)" readonly />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="关联短剧数：">
              <Input :value="displayValue(getRelatedPlayCount())" readonly />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="总集数：">
              <Input :value="displayValue(detail.playTotal)" readonly />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="默认付费卡点：">
              <Input :value="displayValue(detail.defaultPayPoint)" readonly />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="默认二卡：">
              <Input :value="displayValue(detail.defaultSecondPayPoint)" readonly />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="创建时间：">
              <Input :value="displayValue(detail.createTime)" readonly />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="最近同步时间：">
              <Input :value="displayValue(detail.lastSyncTime)" readonly />
            </FormItem>
          </Col>
          <Col :span="24">
            <FormItem label="题材类型：">
              <div v-if="detail.tags && detail.tags.length" class="tag-group">
                <Tag
                  v-for="(item, index) in detail.tags"
                  :key="item.id || item.tagName || index"
                  color="blue"
                >
                  {{ item.tagName || '—' }}
                </Tag>
              </div>
              <span v-else class="empty-value">—</span>
            </FormItem>
          </Col>
          <Col :span="24">
            <FormItem label="关联短剧：">
              <div
                v-if="detail.relatedPlays && detail.relatedPlays.length"
                class="related-table"
              >
                <Table
                  :data="detail.relatedPlays"
                  :columns="relatedColumns"
                  :pagination="false"
                  size="small"
                >
                  <template #view="{ row }">
                    <a @click="handleViewShortPlay(row)">查看短剧</a>
                  </template>
                </Table>
              </div>
              <span v-else class="empty-value">—</span>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import dayjs from 'dayjs'
import { getPrimaryInfo, getPrimaryList } from '@/api/play'
import { getLangList } from '@/api/lang'

export default {
  name: 'PrimaryPlay',
  components: {
    Pages
  },
  data() {
    return {
      channelList: [
        { label: '女性', value: '女性' },
        { label: '男性', value: '男性' },
        { label: '通用', value: '通用' },
        { label: '耽美', value: '耽美' },
        { label: '空频道', value: '__EMPTY__' }
      ],
      channelSelect: '',
      detail: {},
      detailLoading: false,
      langList: [],
      loading: false,
      searchForm: {
        keyword: '',
        type: '',
        originalLangId: '',
        channel: '',
        channelEmpty: false
      },
      viewVisible: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      relatedColumns: [
        {
          title: '短剧名称',
          key: 'playName',
          minWidth: 120,
          tooltip: true,
          render: (h, { row }) => h('span', this.displayValue(row.playName))
        },
        {
          title: '语言',
          key: 'langName',
          minWidth: 90,
          render: (h, { row }) => h('span', this.displayValue(row.langName))
        },
        {
          title: '发行版本类型',
          key: 'versionTypeName',
          minWidth: 110,
          render: (h, { row }) => h('span', this.displayValue(row.versionTypeName))
        },
        {
          title: 'APP 短剧 ID',
          key: 'id',
          width: 110,
          render: (h, { row }) => h('span', this.displayValue(row.id))
        },
        {
          title: '发布状态',
          key: 'playReleaseName',
          minWidth: 90,
          render: (h, { row }) => h('span', this.displayValue(row.playReleaseName))
        },
        {
          title: '最近同步时间',
          key: 'lastSyncTime',
          minWidth: 150,
          render: (h, { row }) =>
            h('span', row.lastSyncTime ? dayjs(row.lastSyncTime).format('YYYY-MM-DD HH:mm:ss') : '—')
        },
        {
          title: '操作',
          align: 'center',
          width: 100,
          slot: 'view'
        }
      ],
      tableData: [],
      columns: [
        {
          title: '主剧名称',
          key: 'playName',
          minWidth: 140,
          tooltip: true
        },
        {
          title: '中文剧名',
          key: 'chineseName',
          minWidth: 140,
          tooltip: true,
          render: (h, { row }) => h('span', this.displayValue(row.chineseName))
        },
        {
          title: '原始语言',
          key: 'originalLangName',
          minWidth: 100,
          render: (h, { row }) => h('span', this.displayValue(row.originalLangName))
        },
        {
          title: '类型',
          key: 'type',
          minWidth: 100,
          render: (h, { row }) => h('span', this.displayValue(row.type))
        },
        {
          title: '频道',
          key: 'channel',
          minWidth: 90,
          render: (h, { row }) => h('span', this.displayValue(row.channel))
        },
        {
          title: '关联短剧数',
          key: 'relatedPlayCount',
          minWidth: 110,
          render: (h, { row }) => h('span', this.displayValue(row.relatedPlayCount))
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 165,
          render: (h, { row }) => h('span', this.displayValue(row.createTime))
        },
        {
          title: '最近同步时间',
          key: 'lastSyncTime',
          minWidth: 165,
          render: (h, { row }) => h('span', this.displayValue(row.lastSyncTime))
        },
        {
          title: '操作',
          align: 'center',
          width: 90,
          fixed: 'right',
          slot: 'action'
        }
      ]
    }
  },
  methods: {
    displayValue(value) {
      return value === null || value === undefined || value === '' ? '—' : String(value)
    },
    getRelatedPlayCount() {
      if (this.detail.relatedPlayCount !== undefined && this.detail.relatedPlayCount !== null) {
        return this.detail.relatedPlayCount
      }
      return Array.isArray(this.detail.relatedPlays) ? this.detail.relatedPlays.length : null
    },
    getLanguageList() {
      getLangList({ current: -1, size: -1, langStatus: true }).then(({ data }) => {
        this.langList = data.records || []
      })
    },
    getData(page) {
      this.page.current = page || 1
      this.loading = true
      const params = {
        ...this.page,
        keyword: this.searchForm.keyword || undefined,
        type: this.searchForm.type || undefined,
        originalLangId: this.searchForm.originalLangId || undefined,
        channel: this.searchForm.channel || undefined,
        channelEmpty: this.searchForm.channelEmpty ? true : undefined
      }
      getPrimaryList(params).then(({ data }) => {
        this.tableData = data.records || []
        this.page.current = data.current
        this.page.total = data.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleView(row) {
      this.detail = { ...row }
      this.viewVisible = true
      this.detailLoading = true
      getPrimaryInfo(row.id).then(({ data }) => {
        this.detail = data || {}
      }).finally(() => {
        this.detailLoading = false
      })
    },
    handleViewShortPlay(row) {
      if (!row.id) return
      this.$router.push({ path: '/play', query: { playId: row.id } })
    },
    handleChannelChange(value) {
      if (value === '__EMPTY__') {
        this.searchForm.channel = ''
        this.searchForm.channelEmpty = true
      } else {
        this.searchForm.channel = value || ''
        this.searchForm.channelEmpty = false
      }
    },
    handleReset() {
      this.searchForm = {
        keyword: '',
        type: '',
        originalLangId: '',
        channel: '',
        channelEmpty: false
      }
      this.channelSelect = ''
      this.getData()
    }
  },
  mounted() {
    this.getLanguageList()
    this.getData()
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;

  & > * {
    width: 200px;
    margin: 0 10px 10px 0;
  }

  .ivu-checkbox-wrapper,
  .ivu-btn {
    width: auto;
  }
}

.table-wrapper {
  height: 100%;
  overflow: auto;
}

.detail-form {
  padding-top: 16px;
}

.tag-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 32px;
  padding: 4px 0;

  /deep/ .ivu-tag {
    margin-bottom: 4px;
  }
}

.related-table {
  width: 100%;
  overflow-x: auto;

  /deep/ .ivu-table-wrapper {
    overflow-x: auto;
  }
}

.empty-value {
  color: #999;
}

.layout-card {
  height: 100%;

  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
